import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api.ts';
import { ErrorBox } from '../components/ui.tsx';

/**
 * Retorno da autorização da Shopee (https://berytus.com.br/app/shopee/?state=…&code=…&shop_id=…).
 * Conclui a conexão com o usuário logado; se não estiver logado, o login traz de volta para cá.
 */
export function ShopeeCallback() {
  const [params] = useSearchParams();
  const qc = useQueryClient();
  const code = params.get('code');
  const state = params.get('state');
  const shopId = params.get('shop_id');
  const mainAccountId = params.get('main_account_id');
  const sent = useRef(false);

  const finish = useMutation({
    mutationFn: () => api<{ nickname: string; shopId: number }>('/channels/shopee/callback', {
      method: 'POST', json: { code, state, ...(shopId ? { shopId } : {}), ...(mainAccountId ? { mainAccountId } : {}) },
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['channels'] }),
  });

  useEffect(() => {
    // Uma vez só: o código da Shopee é de uso único (e o modo estrito do React roda efeitos duas vezes).
    if (code && state && !sent.current) {
      sent.current = true;
      finish.mutate();
    }
  }, [code, state]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="page-head"><div><h1>Conectando a Shopee</h1></div></div>
      <div className="panel" style={{ maxWidth: 640 }}>
        {!code || !state ? (
          <p style={{ margin: 0 }}>Este endereço não trouxe a autorização da Shopee. <Link to="/canais">Voltar para Integração de canais</Link>.</p>
        ) : finish.isPending || finish.isIdle ? (
          <p style={{ margin: 0 }}>Concluindo a conexão…</p>
        ) : finish.error ? (
          <div className="stack-y" style={{ gap: 12 }}>
            <ErrorBox error={finish.error} />
            <Link className="btn" to="/canais">Voltar para Integração de canais</Link>
          </div>
        ) : (
          <div className="stack-y" style={{ gap: 12 }}>
            <p style={{ margin: 0 }}>Loja <b>{finish.data?.nickname}</b> (nº {finish.data?.shopId}) conectada à Berytus.</p>
            <Link className="btn primary" to="/canais">Voltar para Integração de canais</Link>
          </div>
        )}
      </div>
    </>
  );
}
